import { HotelGoogleProvider } from "./google";
// import { HotelInsiderProvider } from "./insider"; // İleride eklenecek
// import { HotelSegmentifyProvider } from "./segmentify"; // İleride eklenecek
import appConfig from "@/configs/app-config";

/**
 * Hotel Analytics Service
 * Tüm provider'ları yönetir (Google, Insider, Segmentify vb.)
 */
export class HotelAnalyticsService {
  constructor() {
    this.providers = [];

    // Google Analytics (Hotel)
    if (appConfig.THIRD_PARTY_OPTIONS.GOOGLE.ANALYTICS.ACTIVE) {
      this.providers.push(new HotelGoogleProvider());
    }

    // Insider (ileride eklenecek)
    // if (appConfig.THIRD_PARTY_OPTIONS.INSIDER.ACTIVE) {
    //   this.providers.push(new BusInsiderProvider());
    // }

    // Segmentify (ileride eklenecek)
    // if (appConfig.THIRD_PARTY_OPTIONS.SEGMENTIFY.ACTIVE) {
    //   this.providers.push(new BusSegmentifyProvider());
    // }
  }

  /**
   * Event'i tüm aktif provider'lara gönderir
   * @param {string} event - Event tipi
   * @param {object} data - Event verisi
   */
  track(event, data) {
    this.providers.forEach((provider) => {
      try {
        provider.track(event, data);
      } catch (error) {
        console.error(`Hotel Analytics Provider Error:`, error);
      }
    });
  }
}

export const hotelService = new HotelAnalyticsService();
